import React from 'react';
import { ApiError } from '../../../../api/api';
import { UnitDesignCalculationsResponse } from '../../../designs/design-form/calculations/designCalculationsResponse';
import { UnitFormModel } from './unitFormModel';

export type UnitFieldContextValue = {
  unit: UnitFormModel;
  unitIndex: number;
  designCalculations: {
    response: UnitDesignCalculationsResponse | null;
    inProgress: boolean;
    error: ApiError | null;
  } | null;
  totalAreaInMetresSquared: number;
};

export const UnitFieldContext = React.createContext<UnitFieldContextValue | undefined>(undefined);
